import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchSolicitudesFacturacion,fetchProformas } from '../../../actions';
import getPedidosFechas from '../../../utils/getPedidosFechas';

const VACIO='';
const VACIO_PATH = '123';
class TableContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pedidosXfichaVenta:[],
      solicitudfacturacion:[]
    }
  }

  componentDidMount(){
    this.fnSolicitudFacturacion(this.props.fdvID);
  }

  fnSolicitudFacturacion = (id) =>  {

    this.props.fetchSolicitudesFacturacion(id,VACIO_PATH,VACIO)
    .then((result) => {
      this.setState({ solicitudfacturacion: result.payload.data });
      this.loadProformas(id);
    }).catch((error) => {console.log(error)});
  }



loadProformas = (id) => {
  let pedidos=[];
  this.props.fetchProformas(id).then((result) => {

    const idsProformas = result.payload.data.proformaExistenteList.map(row => row.numProfVeh);
    getPedidosFechas(id, idsProformas).then((result) => {
      idsProformas.forEach((entry,indexPedido) => {
        pedidos = pedidos.concat(result[indexPedido][parseInt(entry,10)].map(pedido => {return parseInt(pedido.nurFichaVtaPedido,10)}))
      })

      this.setState({pedidosXfichaVenta:pedidos})

    });

  }).catch((error) => {
    console.log(error);
  });
}


printcontent = (content)=>
{
    return {__html:content};
}


render() {

  if (this.props.solicitudfacturacion.length===0) {
    return (
      <tbody><tr><td colSpan='6' className='no-before'>No hay registros</td></tr></tbody>
    );
  }

  if (!this.props.solicitudfacturacion.facturacionResponse.length) {
    return (
      <tbody><tr><td colSpan='6' className='no-before'>No hay registros</td></tr></tbody>
    );
  }


  return this.props.solicitudfacturacion.facturacionResponse
  .filter(facturacion => this.state.pedidosXfichaVenta.indexOf(parseInt(facturacion.nurFichaVtaPedido,10))>=0)
  .map((facturacionListado, index) => {

    const isExpanded = index === this.props.rowSelected;
    const rowClass = isExpanded ? 'as row-expanded' : 'as';

    return (
      <tbody key={facturacionListado.numPedidoVehiculo + index} >
        <tr className={rowClass}>
          <td>{facturacionListado.numPedidoVehiculo}</td>
          <td>{moment(facturacionListado.fecCreaReg).format('DD/MM/YYYY HH:mm')}</td>
          <td>{facturacionListado.desDocFact}</td>
          <td>{facturacionListado.desTipoSoli}</td>
          <td>{facturacionListado.desTipoPago}</td>
          <td onClick={() => this.props.toggleRow(index)} />
        </tr>
        <tr className='table-extra'>
          <td colSpan='6'>
            <Panel collapsible expanded={isExpanded} style={{ borderColor: 'transparent', boxShadow: '0 0 0 white', margin: '0', backgroundColor: 'inherit' }}>
              <div className='collapse in'>
              <div className='table-extra-wrap'>
                <ul className='row'>
                  <li className='col-md-2'>
                    <p className='labelInfo'>Contacto Adic.</p>
                    <p>{facturacionListado.txtNombre}</p>
                  </li>
                  <li className='col-md-2'>
                    <p className='labelInfo'>Correo Adic.</p>
                    <p>{facturacionListado.txtCorreo}</p>
                  </li>
                </ul>
              </div>
                <div className='table-extra-wrap'>
                  <ul className='row'>
                    <li className='col-md-2'>
                      <p className='labelInfo'>Observaciones</p>
                      <p class="mb-0">{facturacionListado.obsSolFacturacion}</p>

                    </li>
                  </ul>
                </div>
              </div>
            </Panel>
          </td>
        </tr>
      </tbody>
    );
  });
}
};

function mapStateToProps(state) {
  return {
    pedidos: state.pedidos,
  };
}

export default withRouter(
  connect(mapStateToProps, {
 fetchSolicitudesFacturacion,fetchProformas
  })(TableContent));



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/ContenidoTablas/Facturacion.js